import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ApolloResponse1aeginapbuksm as ApolloResponse } from '../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ApolloResponse.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
  cancel36mj9lv3a0whl as cancel,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Builder4ra56zvvku0a as Builder } from '../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CustomScalarAdapters.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Companion_getInstance3d08n7snrwep7 as Companion_getInstance } from '../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ExecutionContext.mjs';
import { plus310ted5e4i90h as plus } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/FlowCollector.mjs';
import { withContextp2qc4rbktyej as withContext } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { ProducerScopeb3mmhvfa6ll7 as ProducerScope } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Produce.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Builder3d75eph7uovs3 as Builder_0 } from './network/http/HttpNetworkTransport.mjs';
import { Builder3moivcm5iuump as Builder_1 } from './network/ws/WebSocketNetworkTransport.mjs';
import { get_defaultDispatcher3rblue9uzsji2 as get_defaultDispatcher } from './internal/dispatchers.js.mjs';
import { ConcurrencyInfo3mmnli95yq2g0 as ConcurrencyInfo } from './ConcurrencyInfo.mjs';
import { NetworkInterceptor22fszyorwx7pt as NetworkInterceptor } from './interceptor/NetworkInterceptor.mjs';
import { ApolloCallpwdxdy18rzuy as ApolloCall } from './ApolloCall.mjs';
import { channelFlow1or0c85tk04v1 as channelFlow } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Builders.mjs';
import { Dispatchers_getInstance2p2r3ndn98nn as Dispatchers_getInstance } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import {
  flowOn2q2f1gsn1yu9y as flowOn,
  buffer2o7vhreze5nfc as buffer,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Context.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { RetryOnErrorInterceptor28nn2rq891clj as RetryOnErrorInterceptor } from './interceptor/RetryOnErrorInterceptor.mjs';
import { DefaultInterceptorChain10weji0clzo5q as DefaultInterceptorChain } from './interceptor/ApolloInterceptor.mjs';
import { onEach13yrgg7fxnyl6 as onEach } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Transform.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ApolloClient$executeAsFlowInternal$slambda$slambda$slambdaClass;
function ApolloClient$executeAsFlowInternal$slambda$slambda$slambda() {
  if (ApolloClient$executeAsFlowInternal$slambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($this_channelFlow) {
        this.p61_1 = $this_channelFlow;
      }
      *q61(it, $completion) {
        yield* this.p61_1.x1a(it, $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.q61(p1 instanceof ApolloResponse() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ApolloClient$executeAsFlowInternal$slambda$slambda$slambdaClass = $;
  }
  return ApolloClient$executeAsFlowInternal$slambda$slambda$slambdaClass;
}
function ApolloClient$executeAsFlowInternal$slambda$slambda$slambda_0($this_channelFlow) {
  var i = new (ApolloClient$executeAsFlowInternal$slambda$slambda$slambda())($this_channelFlow);
  var l = (it, $completion) => i.q61(it, $completion);
  l.$arity = 1;
  return l;
}
var ApolloClient$executeAsFlowInternal$slambda$slambdaClass;
function ApolloClient$executeAsFlowInternal$slambda$slambda() {
  if (ApolloClient$executeAsFlowInternal$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $apolloRequest, $throwing, $this_channelFlow) {
        this.r61_1 = this$0;
        this.s61_1 = $apolloRequest;
        this.t61_1 = $throwing;
        this.u61_1 = $this_channelFlow;
      }
      *w1f($this$withContext, $completion) {
        var tmp = this.r61_1.v61(this.s61_1, this.t61_1);
        var tmp_0 = ApolloClient$executeAsFlowInternal$slambda$slambda$slambda_0(this.u61_1);
        yield* tmp.u1c(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp_0), $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.w1f((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ApolloClient$executeAsFlowInternal$slambda$slambdaClass = $;
  }
  return ApolloClient$executeAsFlowInternal$slambda$slambdaClass;
}
function ApolloClient$executeAsFlowInternal$slambda$slambda_0(this$0, $apolloRequest, $throwing, $this_channelFlow) {
  var i = new (ApolloClient$executeAsFlowInternal$slambda$slambda())(this$0, $apolloRequest, $throwing, $this_channelFlow);
  var l = ($this$withContext, $completion) => i.w1f($this$withContext, $completion);
  l.$arity = 1;
  return l;
}
var BuilderClass;
function Builder_2() {
  if (BuilderClass === VOID) {
    class $ {
      constructor() {
        this.w61_1 = new (Builder())();
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.x61_1 = ArrayList().p2();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_0.y61_1 = ArrayList().p2();
        var tmp_1 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_1.z61_1 = ArrayList().p2();
        var tmp_2 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_2.a62_1 = ArrayList().p2();
        var tmp_3 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_3.b62_1 = ArrayList().p2();
        this.c62_1 = this.b62_1;
        var tmp_4 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_4.d62_1 = ArrayList().p2();
        this.e62_1 = this.d62_1;
        this.f62_1 = Companion_getInstance().i42_1;
        this.g62_1 = null;
        this.h62_1 = null;
        this.i62_1 = null;
        this.j62_1 = null;
        this.k62_1 = null;
        this.l62_1 = null;
        this.m62_1 = null;
        this.n62_1 = null;
        this.o62_1 = null;
        this.p62_1 = null;
        this.q62_1 = null;
        this.r62_1 = null;
        this.s62_1 = null;
        this.t62_1 = null;
        this.u62_1 = null;
        this.v62_1 = null;
        this.w62_1 = null;
        this.x62_1 = null;
        this.y62_1 = null;
        this.z62_1 = null;
        this.a63_1 = null;
        this.b63_1 = null;
        this.c63_1 = null;
        this.d63_1 = true;
      }
      e63() {
        return this.w61_1.d37();
      }
      f63() {
        return plus(plus(plus(this.x61_1, this.y61_1), this.z61_1), this.a62_1);
      }
      v42(sendEnhancedClientAwareness) {
        // Inline function 'kotlin.apply' call
        this.d63_1 = sendEnhancedClientAwareness;
        return this;
      }
      u42(failFastIfOffline) {
        // Inline function 'kotlin.apply' call
        this.a63_1 = failFastIfOffline;
        return this;
      }
      g63(retryOnError) {
        // Inline function 'kotlin.apply' call
        this.y62_1 = retryOnError;
        return this;
      }
      h63(retryOnErrorInterceptor) {
        // Inline function 'kotlin.apply' call
        this.z62_1 = retryOnErrorInterceptor;
        return this;
      }
      i63(cacheInterceptor) {
        // Inline function 'kotlin.apply' call
        this.b63_1 = cacheInterceptor;
        return this;
      }
      j63(autoPersistedQueryInterceptor) {
        // Inline function 'kotlin.apply' call
        this.c63_1 = autoPersistedQueryInterceptor;
        return this;
      }
      m42(httpMethod) {
        // Inline function 'kotlin.apply' call
        this.g62_1 = httpMethod;
        return this;
      }
      n42(httpHeaders) {
        // Inline function 'kotlin.apply' call
        this.h62_1 = httpHeaders;
        return this;
      }
      p42(sendApqExtensions) {
        // Inline function 'kotlin.apply' call
        this.i62_1 = sendApqExtensions;
        return this;
      }
      q42(sendDocument) {
        // Inline function 'kotlin.apply' call
        this.j62_1 = sendDocument;
        return this;
      }
      r42(enableAutoPersistedQueries) {
        // Inline function 'kotlin.apply' call
        this.k62_1 = enableAutoPersistedQueries;
        return this;
      }
      s42(canBeBatched) {
        // Inline function 'kotlin.apply' call
        this.l62_1 = canBeBatched;
        return this;
      }
      k63(serverUrl) {
        // Inline function 'kotlin.apply' call
        this.p62_1 = serverUrl;
        return this;
      }
      l63(httpServerUrl) {
        // Inline function 'kotlin.apply' call
        this.p62_1 = httpServerUrl;
        return this;
      }
      m63(httpEngine) {
        // Inline function 'kotlin.apply' call
        this.q62_1 = httpEngine;
        return this;
      }
      n63(httpExposeErrorBody) {
        // Inline function 'kotlin.apply' call
        this.u62_1 = httpExposeErrorBody;
        return this;
      }
      o63(httpInterceptors) {
        // Inline function 'kotlin.apply' call
        this.b62_1.a5();
        this.b62_1.u2(httpInterceptors);
        return this;
      }
      p63(webSocketServerUrl) {
        // Inline function 'kotlin.apply' call
        this.r62_1 = webSocketServerUrl;
        return this;
      }
      q63(webSocketServerUrl) {
        // Inline function 'kotlin.apply' call
        this.x62_1 = webSocketServerUrl;
        return this;
      }
      r63(webSocketIdleTimeoutMillis) {
        // Inline function 'kotlin.apply' call
        this.s62_1 = webSocketIdleTimeoutMillis;
        return this;
      }
      s63(wsProtocolFactory) {
        // Inline function 'kotlin.apply' call
        this.t62_1 = wsProtocolFactory;
        return this;
      }
      t63(webSocketEngine) {
        // Inline function 'kotlin.apply' call
        this.v62_1 = webSocketEngine;
        return this;
      }
      u63(webSocketReopenWhen) {
        // Inline function 'kotlin.apply' call
        this.w62_1 = webSocketReopenWhen;
        return this;
      }
      v63(networkTransport) {
        // Inline function 'kotlin.apply' call
        this.m62_1 = networkTransport;
        return this;
      }
      w63(subscriptionNetworkTransport) {
        // Inline function 'kotlin.apply' call
        this.n62_1 = subscriptionNetworkTransport;
        return this;
      }
      x63(customScalarAdapters) {
        // Inline function 'kotlin.apply' call
        this.w61_1.a5();
        this.w61_1.y45(customScalarAdapters);
        return this;
      }
      y63(listeners) {
        // Inline function 'kotlin.apply' call
        this.d62_1.a5();
        this.d62_1.u2(listeners);
        return this;
      }
      z63(dispatcher) {
        // Inline function 'kotlin.apply' call
        this.o62_1 = dispatcher;
        return this;
      }
      k42(executionContext) {
        // Inline function 'kotlin.apply' call
        this.f62_1 = executionContext;
        return this;
      }
      d37() {
        return new (ApolloClient())(this.y37());
      }
      y37() {
        // Inline function 'kotlin.also' call
        var this_0 = (new (Builder_2())()).x63(this.w61_1.d37());
        this_0.x61_1.u2(this.x61_1);
        this_0.y61_1.u2(this.y61_1);
        this_0.z61_1.u2(this.z61_1);
        this_0.a62_1.u2(this.a62_1);
        return this_0.z63(this.o62_1).k42(this.f62_1).m42(this.g62_1).n42(this.h62_1).l63(this.p62_1).m63(this.q62_1).n63(this.u62_1).o63(this.c62_1).p42(this.i62_1).q42(this.j62_1).r42(this.k62_1).s42(this.l62_1).v63(this.m62_1).w63(this.n62_1).p63(this.r62_1).q63(this.x62_1).t63(this.v62_1).u63(this.w62_1).r63(this.s62_1).s63(this.t62_1).g63(this.y62_1).h63(this.z62_1).i63(this.b63_1).j63(this.c63_1).u42(this.a63_1).y63(this.e62_1).v42(this.d63_1);
      }
    }
    initMetadataForClass($, 'Builder', Builder_2);
    BuilderClass = $;
  }
  return BuilderClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  return Companion_instance;
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class;
function sam$kotlinx_coroutines_flow_FlowCollector$0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.a64_1 = function_0;
      }
      *m1d(value, $completion) {
        return yield* this.a64_1(value, $completion);
      }
      i5() {
        return this.a64_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i5(), other.i5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i5());
      }
    }
    initMetadataForClass($, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class = $;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class;
}
var ApolloClient$executeAsFlowInternal$slambdaClass;
function ApolloClient$executeAsFlowInternal$slambda() {
  if (ApolloClient$executeAsFlowInternal$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $apolloRequest, $throwing) {
        this.b64_1 = this$0;
        this.c64_1 = $apolloRequest;
        this.d64_1 = $throwing;
      }
      *e64($this$channelFlow, $completion) {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = this.b64_1.d61_1.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          element.f64(this.c64_1);
        }
        try {
          yield* withContext(this.b64_1.t60_1.g64_1, ApolloClient$executeAsFlowInternal$slambda$slambda_0(this.b64_1, this.c64_1, this.d64_1, $this$channelFlow), $completion);
        }finally {
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s_0 = this.b64_1.d61_1.p1();
          while (_iterator__ex2g4s_0.q1()) {
            var element_0 = _iterator__ex2g4s_0.r1();
            element_0.i64(this.c64_1);
          }
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.e64((!(p1 == null) ? isInterface(p1, ProducerScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ApolloClient$executeAsFlowInternal$slambdaClass = $;
  }
  return ApolloClient$executeAsFlowInternal$slambdaClass;
}
function ApolloClient$executeAsFlowInternal$slambda_0(this$0, $apolloRequest, $throwing) {
  var i = new (ApolloClient$executeAsFlowInternal$slambda())(this$0, $apolloRequest, $throwing);
  var l = ($this$channelFlow, $completion) => i.e64($this$channelFlow, $completion);
  l.$arity = 1;
  return l;
}
var ApolloClient$apolloResponses$slambdaClass;
function ApolloClient$apolloResponses$slambda() {
  if (ApolloClient$apolloResponses$slambdaClass === VOID) {
    class $ {
      *q61(response, $completion) {
        if (!(response.g44_1 == null)) {
          throw ensureNotNull(response.g44_1);
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.q61(p1 instanceof ApolloResponse() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ApolloClient$apolloResponses$slambdaClass = $;
  }
  return ApolloClient$apolloResponses$slambdaClass;
}
function ApolloClient$apolloResponses$slambda_0() {
  var i = new (ApolloClient$apolloResponses$slambda())();
  var l = (response, $completion) => i.q61(response, $completion);
  l.$arity = 1;
  return l;
}
var ApolloClientClass;
function ApolloClient() {
  if (ApolloClientClass === VOID) {
    class $ {
      constructor(builder) {
        this.s60_1 = builder;
        this.w60_1 = this.s60_1.f63();
        this.x60_1 = this.s60_1.e63();
        this.y60_1 = this.s60_1.b63_1;
        this.z60_1 = this.s60_1.c63_1;
        this.a61_1 = this.s60_1.y62_1;
        this.b61_1 = this.s60_1.z62_1;
        this.c61_1 = this.s60_1.a63_1;
        this.d61_1 = this.s60_1.e62_1;
        this.e61_1 = this.s60_1.d63_1;
        this.f61_1 = this.s60_1.f62_1;
        this.g61_1 = this.s60_1.g62_1;
        this.h61_1 = this.s60_1.h62_1;
        this.i61_1 = this.s60_1.i62_1;
        this.j61_1 = this.s60_1.j62_1;
        this.k61_1 = this.s60_1.k62_1;
        this.l61_1 = this.s60_1.l62_1;
        var tmp = this;
        var tmp_0;
        if (!(this.s60_1.m62_1 == null)) {
          // Inline function 'kotlin.check' call
          if (!(this.s60_1.p62_1 == null)) {
            var message = "Apollo: 'httpServerUrl' has no effect if 'networkTransport' is set. Configure httpServerUrl on the networkTransport directly.";
            throw IllegalStateException().o(toString(message));
          }
          // Inline function 'kotlin.check' call
          if (!(this.s60_1.q62_1 == null)) {
            var message_0 = "Apollo: 'httpEngine' or 'okHttpClient' has no effect if 'networkTransport' is set. Configure httpEngine on the networkTransport directly.";
            throw IllegalStateException().o(toString(message_0));
          }
          // Inline function 'kotlin.check' call
          if (!this.s60_1.c62_1.n1()) {
            var message_1 = "Apollo: 'addHttpInterceptor' has no effect if 'networkTransport' is set. Configure the interceptors on the networkTransport directly.";
            throw IllegalStateException().o(toString(message_1));
          }
          // Inline function 'kotlin.check' call
          if (!(this.s60_1.u62_1 == null)) {
            var message_2 = "Apollo: 'httpExposeErrorBody' has no effect if 'networkTransport' is set. Configure httpExposeErrorBody on the networkTransport directly.";
            throw IllegalStateException().o(toString(message_2));
          }
          tmp_0 = ensureNotNull(this.s60_1.m62_1);
        } else {
          // Inline function 'kotlin.check' call
          if (!!(this.s60_1.p62_1 == null)) {
            var message_3 = "Apollo: 'serverUrl' is required";
            throw IllegalStateException().o(toString(message_3));
          }
          // Inline function 'kotlin.apply' call
          var this_0 = (new (Builder_0())()).k63(ensureNotNull(this.s60_1.p62_1));
          if (!(this.s60_1.q62_1 == null)) {
            this_0.p64(ensureNotNull(this.s60_1.q62_1));
          }
          if (!(this.s60_1.u62_1 == null)) {
            this_0.q64(ensureNotNull(this.s60_1.u62_1));
          }
          tmp_0 = this_0.r64(this.s60_1.c62_1).d37();
        }
        tmp.u60_1 = tmp_0;
        var tmp_1 = this;
        var tmp_2;
        if (!(this.s60_1.n62_1 == null)) {
          // Inline function 'kotlin.check' call
          if (!(this.s60_1.r62_1 == null)) {
            var message_4 = "Apollo: 'webSocketServerUrl' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketServerUrl on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_4));
          }
          // Inline function 'kotlin.check' call
          if (!(this.s60_1.v62_1 == null)) {
            var message_5 = "Apollo: 'webSocketEngine' or 'okHttpClient' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketEngine on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_5));
          }
          // Inline function 'kotlin.check' call
          if (!(this.s60_1.s62_1 == null)) {
            var message_6 = "Apollo: 'webSocketIdleTimeoutMillis' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketIdleTimeoutMillis on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_6));
          }
          // Inline function 'kotlin.check' call
          if (!(this.s60_1.t62_1 == null)) {
            var message_7 = "Apollo: 'wsProtocolFactory' has no effect if 'subscriptionNetworkTransport' is set. Configure wsProtocolFactory on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_7));
          }
          // Inline function 'kotlin.check' call
          if (!(this.s60_1.w62_1 == null)) {
            var message_8 = "Apollo: 'webSocketReopenWhen' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketReopenWhen on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_8));
          }
          // Inline function 'kotlin.check' call
          if (!(this.s60_1.x62_1 == null)) {
            var message_9 = "Apollo: 'webSocketReopenServerUrl' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketReopenServerUrl on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_9));
          }
          tmp_2 = ensureNotNull(this.s60_1.n62_1);
        } else {
          var tmp0_elvis_lhs = this.s60_1.r62_1;
          var url = tmp0_elvis_lhs == null ? this.s60_1.p62_1 : tmp0_elvis_lhs;
          var tmp_3;
          if (url == null) {
            tmp_3 = this.u60_1;
          } else {
            // Inline function 'kotlin.apply' call
            var this_1 = (new (Builder_1())()).k63(url);
            if (!(this.s60_1.v62_1 == null)) {
              this_1.y64(ensureNotNull(this.s60_1.v62_1));
            }
            if (!(this.s60_1.s62_1 == null)) {
              this_1.z64(ensureNotNull(this.s60_1.s62_1));
            }
            if (!(this.s60_1.t62_1 == null)) {
              this_1.a65(ensureNotNull(this.s60_1.t62_1));
            }
            if (!(this.s60_1.w62_1 == null)) {
              this_1.b65(this.s60_1.w62_1);
            }
            if (!(this.s60_1.x62_1 == null)) {
              this_1.c65(this.s60_1.x62_1);
            }
            tmp_3 = this_1.d37();
          }
          tmp_2 = tmp_3;
        }
        tmp_1.v60_1 = tmp_2;
        var tmp1_elvis_lhs = this.s60_1.o62_1;
        var dispatcher = tmp1_elvis_lhs == null ? get_defaultDispatcher() : tmp1_elvis_lhs;
        this.t60_1 = new (ConcurrencyInfo())(dispatcher, CoroutineScope_0(dispatcher));
        this.m61_1 = new (NetworkInterceptor())(this.u60_1, this.v60_1);
      }
      d65(query) {
        return ApolloCall().q60(this, query);
      }
      e65(mutation) {
        return ApolloCall().q60(this, mutation);
      }
      l6() {
        cancel(this.t60_1.h64_1);
        this.u60_1.oz();
        this.v60_1.oz();
      }
      n61(apolloRequest, throwing) {
        var flow = channelFlow(ApolloClient$executeAsFlowInternal$slambda_0(this, apolloRequest, throwing));
        return buffer(flowOn(flow, Dispatchers_getInstance().d13_1), 2147483647);
      }
      v61(apolloRequest, throwing) {
        var apolloClient = this;
        // Inline function 'kotlin.apply' call
        var this_0 = apolloRequest.j43();
        this_0.k42(this.t60_1.w43(this.x60_1).w43(apolloClient.f61_1).w43(this_0.x41_1));
        var tmp0_elvis_lhs = this_0.y41_1;
        this_0.m42(tmp0_elvis_lhs == null ? apolloClient.g61_1 : tmp0_elvis_lhs);
        var tmp1_elvis_lhs = this_0.b42_1;
        this_0.p42(tmp1_elvis_lhs == null ? apolloClient.i61_1 : tmp1_elvis_lhs);
        var tmp2_elvis_lhs = this_0.c42_1;
        this_0.q42(tmp2_elvis_lhs == null ? apolloClient.j61_1 : tmp2_elvis_lhs);
        var tmp3_elvis_lhs = this_0.a42_1;
        this_0.r42(tmp3_elvis_lhs == null ? apolloClient.k61_1 : tmp3_elvis_lhs);
        // Inline function 'kotlin.collections.buildList' call
        // Inline function 'kotlin.collections.buildListInternal' call
        // Inline function 'kotlin.apply' call
        var this_1 = ArrayList().p2();
        if (!(this_0.e42_1 === true)) {
          // Inline function 'kotlin.collections.orEmpty' call
          var tmp0_elvis_lhs_0 = apolloClient.h61_1;
          var tmp$ret$6 = tmp0_elvis_lhs_0 == null ? emptyList() : tmp0_elvis_lhs_0;
          this_1.u2(tmp$ret$6);
        }
        // Inline function 'kotlin.collections.orEmpty' call
        var tmp0_elvis_lhs_1 = this_0.z41_1;
        var tmp$ret$7 = tmp0_elvis_lhs_1 == null ? emptyList() : tmp0_elvis_lhs_1;
        this_1.u2(tmp$ret$7);
        var headers = this_1.f8();
        this_0.n42(headers);
        var tmp4_elvis_lhs = this_0.d42_1;
        var canBeBatched = tmp4_elvis_lhs == null ? apolloClient.l61_1 : tmp4_elvis_lhs;
        if (!(canBeBatched == null)) {
          this_0.o42('X-APOLLO-CAN-BE-BATCHED', canBeBatched.toString());
        }
        var tmp5_elvis_lhs = this_0.f42_1;
        var tmp;
        if (tmp5_elvis_lhs == null) {
          var tmp6_safe_receiver = apolloClient.a61_1;
          tmp = tmp6_safe_receiver == null ? null : tmp6_safe_receiver(apolloRequest);
        } else {
          tmp = tmp5_elvis_lhs;
        }
        this_0.t42(tmp);
        var tmp7_elvis_lhs = this_0.g42_1;
        this_0.u42(tmp7_elvis_lhs == null ? apolloClient.c61_1 : tmp7_elvis_lhs);
        this_0.v42(apolloClient.e61_1);
        var request = this_0.d37();
        // Inline function 'kotlin.collections.buildList' call
        // Inline function 'kotlin.collections.buildListInternal' call
        // Inline function 'kotlin.apply' call
        var this_2 = ArrayList().p2();
        this_2.u2(this.s60_1.x61_1);
        if (!(this.y60_1 == null)) {
          this_2.i2(this.y60_1);
        }
        this_2.u2(this.s60_1.y61_1);
        if (!(this.z60_1 == null)) {
          this_2.i2(this.z60_1);
        }
        this_2.u2(this.s60_1.z61_1);
        var tmp0_elvis_lhs_2 = this.b61_1;
        this_2.i2(tmp0_elvis_lhs_2 == null ? RetryOnErrorInterceptor() : tmp0_elvis_lhs_2);
        this_2.u2(this.s60_1.a62_1);
        this_2.i2(this.m61_1);
        var allInterceptors = this_2.f8();
        // Inline function 'kotlin.let' call
        var it = (new (DefaultInterceptorChain())(allInterceptors, 0)).h65(request);
        var tmp_0;
        if (throwing) {
          tmp_0 = onEach(it, ApolloClient$apolloResponses$slambda_0());
        } else {
          tmp_0 = it;
        }
        return tmp_0;
      }
    }
    initMetadataForClass($, 'ApolloClient');
    ApolloClientClass = $;
  }
  return ApolloClientClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Builder_2 as Builder3lcn00uc5gcy3,
};
//endregion

//# sourceMappingURL=ApolloClient.mjs.map
